import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import * as Managers from "../Managers";
import { DataService } from '../DataService/DataService';
import { ModalManager } from '../Managers/ModalManager';
import { ModalTranslationTypes } from '../Models/ModalTranslationTypes';
import { DefaultBlockTrigger } from '../Enums/DefaultBlockTrigger';
import { BannerDismissFor } from '../Enums/BannerDismissFor';
import { CookieHelper } from '../Helpers/CookieHelper';
import { EmailFormResult } from '../Models/EmailFormResult';
import { ElementHelper } from '../Helpers/ElementHelper';

declare function initParallax():any
export class BlockManager {

    constructor(private containerElement: JQuery) {
    }

    private blockName : string;
    private blockTag : string;

    public initialize(zIndex : undefined | number) {
        var containerElement = $(this.containerElement);

        this.blockName = containerElement.data('block-name');
        this.blockTag = containerElement.data('block-tag');
        let parentId = containerElement.data('parent-id');
        let parentType = containerElement.data('parent-type');

        this.containerElement.load(encodeURI(`/block?name=${this.blockName}&tag=${this.blockTag}&parentId=${parentId}&parentType=${parentType}`),
        () => {
            this.initializeBlock(zIndex);
        });
    }

    public initializeWithoutLoad(zIndex : undefined | number) {
        var containerElement = $(this.containerElement);

        this.blockName = containerElement.data('block-name');
        this.blockTag = containerElement.data('block-tag');
        this.initializeBlock(zIndex);
    }


    private initializeBlock(zIndex : undefined | number) {
        Swiper.use([Navigation, Pagination, Autoplay]);

        var firstElement = this.containerElement.children().first();
        if(zIndex != undefined) {
            firstElement.css('z-index', zIndex);
        }

        var parallaxElement = firstElement.find('.img-parallax');
        if(parallaxElement.length >= 1) {
            this.bindParallax(parallaxElement);
        }
        

        this.containerElement.find('.swiper-container').each((index, element) => {

            var autoplay : boolean = $(element).data('autoplay');
            var mySwiper = new Swiper(element,
            {
                slidesOffsetBefore: -1,
                // Optional parameters
                direction: 'horizontal',
                loop: true,
                spaceBetween: 0,
                centeredSlides: true,
                autoplay: autoplay == true ? {
                    delay: 5000
                } : false,
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                      },  
                      576: {
                          slidesPerView: 2,
                        },        
                      992: {
                        slidesPerView: 3,
                      },
                },
                // If we need pagination
                pagination: {
                    el: firstElement.find('.swiper-pagination')[0],
                    clickable: true
                },

                // Navigation arrows
                navigation: {
                    nextEl: firstElement.find('.swiper-button-next')[0],
                    prevEl: firstElement.find('.swiper-button-prev')[0],
                },

            });
        });

        this.containerElement.find('.swiper-timeline').each((index, element) => {
            var timelineElement = $(element);
            const timelineSwiper = new Swiper(element,
                {
                    // Optional parameters
                    direction: 'horizontal',
                    loop: true,
                    slidesPerView: 'auto',

                    // If we need pagination
                    pagination: {
                        el: timelineElement.find('.swiper-pagination')[0],
                        clickable: true
                    },

                    // Navigation arrows
                    navigation: {
                        nextEl: timelineElement.find('.swiper-button-next')[0],
                        prevEl: timelineElement.find('.swiper-button-prev')[0],
                    },

                });
        });

        this.containerElement.find('.swiper-challenge').each((index, element) => {

            const challengeSwiper = new Swiper(element,
                {
                    // Optional parameters
                    direction: 'horizontal',
                    loop: false,
                    slidesPerView: 'auto',
                    spaceBetween: 20,

                    // If we need pagination
                    pagination: {
                        el: firstElement.find('.swiper-pagination')[0],
                        clickable: true
                    },
                    navigation: {
                        nextEl: firstElement.find('.swiper-button-next')[0],
                        prevEl: firstElement.find('.swiper-button-prev')[0],
                    },
                });
        });

        this.containerElement.find('.swiper-spotlight').each((index, element) => {

            var parsedSwiperElement = $(element);
            var amountOfItems = +parsedSwiperElement.data('amount-of-items');
            const spotlightSwiper = new Swiper(element,
                {
                    // Optional parameters
                    direction: 'horizontal',
                    loop: true,
                    slidesPerView: 'auto',
                    spaceBetween: 0,
                    breakpoints: {
                        0: {
                            centeredSlides: true,
                        },  
                        576: {
                            centeredSlides: false,
                        },
                        992: {
                            loop: amountOfItems >= 3 ? true : false,
                            
                          },
                    },

                    pagination: {
                        el: amountOfItems >= 3 ? firstElement.find('.swiper-pagination')[0] : undefined,
                    },

                    navigation: {
                        nextEl: firstElement.find('.swiper-button-next')[0],
                        prevEl: firstElement.find('.swiper-button-prev')[0],
                        disabledClass: amountOfItems > 3 || amountOfItems < 3 ? 'disabled_swiper_button' : undefined
                    },
                });
        });

        this.containerElement.find('.swiper-chrono').each((index, element) => {
            var ww = $(window).width();
            var slidesPerView : any = 'auto';  
            if (ww<=576) {
                slidesPerView = 1;
            } else {
                slidesPerView = 'auto';
            }

            var chronologic = new Swiper(element,
            {
                // Optional parameters
                direction: 'horizontal',
                loop: false,
                slidesPerView : slidesPerView,

                // If we need pagination
                pagination: {
                    el: firstElement.find('.swiper-pagination')[0],
                    clickable: true
                },
                navigation: {
                    nextEl: firstElement.find('.swiper-button-next')[0],
                    prevEl: firstElement.find('.swiper-button-prev')[0],
                },
            });

               
                $(window).resize(function(){
                    var ww = $(window).width();
                    if (ww<=576) {
                        chronologic.params.slidesPerView = 1;
                    } else {
                        chronologic.params.slidesPerView = 'auto';
                    }
                });  
                

        });

        firstElement.find('.swiper-update-list').each((index, element) => {

            const updateList = new Swiper(element,
                {
                    // Optional parameters
                    direction: 'horizontal',
                    loop: true,
                    slidesPerView: 'auto',
                    spaceBetween: 12,
                    breakpoints: {
                        0: {
                            centeredSlides: true,
                        },  
                        576: {
                            centeredSlides: false,
                        }
                    },
                    // If we need pagination
                    pagination: {
                        el: firstElement.find('.swiper-pagination')[0],
                        clickable: true
                    },

                    // Navigation arrows
                    navigation: {
                        nextEl: firstElement.find('.swiper-button-next')[0],
                        prevEl: firstElement.find('.swiper-button-prev')[0],
                    },
                });
        });

        firstElement.find('.swiper-match-list').each((index, element) => {
            var matchListElement = $(element);
            const matchSwiper = new Swiper(element,
                {
                    // Optional parameters
                    direction: 'horizontal',
                    loop: true,
                    slidesPerView: 'auto',
                    spaceBetween: 12,
                    breakpoints: {
                        0: {
                            centeredSlides: true,
                        },  
                        576: {
                            centeredSlides: true,
                        }
                    },

                    // Navigation arrows
                    navigation: {
                        nextEl: matchListElement.find('.swiper-button-next')[0],
                        prevEl: matchListElement.find('.swiper-button-prev')[0],
                    },

                });
        });

        this.containerElement.find('.custom-content-cards-slider').each((index, element) => {

            var htmlElement = $(element);
            var slidersPerViewForMobile = +htmlElement.data('slides-per-view-mobile');
            var slidersPerViewForTablet = +htmlElement.data('slides-per-view-tablet');
            var slidersPerViewForDesktop = +htmlElement.data('slides-per-view-desktop');

            const customContentCardsSlider = new Swiper(element, {
                direction: "horizontal",
                loop: false,
                spaceBetween: 20,

                // If we need pagination
                pagination: {
                    el: firstElement.find('.swiper-pagination')[0],
                    clickable: true
                },

                // Navigation arrows
                navigation: {
                    nextEl: firstElement.find('.swiper-button-next')[0],
                    prevEl: firstElement.find('.swiper-button-prev')[0],
                },

                breakpoints: {
                    0: {
                        slidesPerView: slidersPerViewForMobile,
                    },
                    576: {
                        slidesPerView: slidersPerViewForTablet,
                    },
                    1200: {
                        slidesPerView: slidersPerViewForDesktop,
                    },
                },
            });
        });

        if (this.blockName === 'newsletter-widget') {
            this.bindNewsletter(this.containerElement, this.blockTag, undefined);
        }
        else if(this.blockName === 'header-navigation') {
            this.bindHeaderNavigation(firstElement);
        }
        else if(this.blockName === 'hub-header') {
            this.bindHubHeader(firstElement);
        }
        else if(this.blockName === 'showcase') {
            this.bindShowcase();
        }
        else if(this.blockName === 'slider') {
            this.bindSlider();
        }
        else if (this.blockName === 'cookie') {
            this.bindCookie();
        }
        else if (this.blockName === 'side-banner') {
            this.bindSideBanner(firstElement);
        }
        else if (this.blockName === 'banner') {
            this.bindBanner(firstElement);
        }
        else if (this.blockName === 'popup') {
            this.bindPopup(firstElement);
        }  
        else if (this.blockName === 'icon-row') {
            this.bindIconRow(firstElement);
        }
        else if (this.blockName === 'challenge-widget' || this.blockName === 'challenges-overview') {
            new Managers.ChallengeWidgetManager(firstElement).initialize();
        }
        else if (this.blockName === 'update-widget' || this.blockName === 'updates-overview') {
            new Managers.UpdateListManager(firstElement).initialize();
        }
        else if (this.blockName === 'match-widget') {
            new Managers.MatchListManager(firstElement).initialize();
        }
        else if (this.blockName === 'partners-widget') {
            new Managers.PartnerListManager(firstElement).initialize();
        }
        else if (this.blockName === 'email-form-block') {
            this.bindEmailFormBlock(firstElement);
        }
        else if (this.blockName === 'faq') {
            this.bindFaqBlock(firstElement);
        }

        this.containerElement.find('#returnUrl').each((index, element) => {

            $(element).val(window.location.href);
        });

        this.containerElement.find('#faq-container').each((index, element) => {
            new Managers.FaqManager($(element).parent()).initialize();
        });

        ElementHelper.bindListItemsWithHref(this.containerElement);

        ElementHelper.reformatHeightElements(this.containerElement);

        this.containerElement.children('div').first().prop('id', this.blockTag);
                        
        this.containerElement.children(':first').unwrap();

        this.bindQuickLink(firstElement);
    }

    private bindQuickLink(firstElement : JQuery<HTMLElement>) {
        setTimeout(() => {
            var editBlockButton : JQuery<HTMLElement> = firstElement.find('.edit-block-button');
            var addEntityButton : JQuery<HTMLElement> = firstElement.find('.add-entity-button');
            var editBlocktext : JQuery<HTMLElement> = firstElement.find('.edit-block-text');
            var transparentMenuElement = firstElement.prev();
            if(transparentMenuElement.length >= 1 && transparentMenuElement.hasClass('menu--transparent')) {
                let marginTop = +transparentMenuElement.css("marginBottom").replace('px', '').replace('-', '');
                if(editBlockButton.length >= 1) {
                    var currentTop = editBlockButton.position().top;
                    editBlockButton.css('top', `${currentTop + marginTop}px`)
                    editBlocktext.css('top', `${currentTop + marginTop}px`)
                }

                if(addEntityButton.length >= 1) {
                    var currentTop = addEntityButton.position().top;
                    addEntityButton.css('top', `${currentTop + marginTop}px`)
                }
            }

            editBlockButton.removeClass('d-none');
            addEntityButton.removeClass('d-none');
        }, 450)
    }

    private bindHubHeader(firstElement : JQuery<HTMLElement>) {
        if ($(".hub-header").hasClass("full-height-vh")) {
            $(".hub-header__circle").show();
        }
    
        $(".hub-header__circle").click(function (e) {
            e.preventDefault();
            window.scroll(0, screen.height / 2);
        });
    }

    private bindHeaderNavigation(firstElement) {
        const menuToggler = document.querySelector('.header__toggler_container');
        const hamburger = menuToggler?.querySelector('.hamburger');
        const menu_items = document.querySelector('.menu__items--mobile');
        const body = document.querySelector("html");
        const html = document.querySelector("body");
        const menu = hamburger?.closest('.menu');
        var foundMenu = menu != undefined ? $(menu) : undefined;

        if (menuToggler && hamburger) {
            menuToggler.addEventListener("click", () => {
                if (hamburger.classList.contains("header__toggler--active")) {
                    hamburger.classList.remove("header__toggler--active");
                    //body.style.overflowY = "initial";
                    //html.style.overflowY = "initial";
                    menu_items.classList.remove("open-menu");
                    menu_items.classList.add("closed-menu");

                    if(foundMenu != undefined) {
                        foundMenu.css("z-index", "9");
                    }

                } else {
                    //body.style.overflowY = "hidden";
                    //html.style.overflowY = "hidden";
            
                    hamburger.classList.add("header__toggler--active");
                    menu_items.classList.remove("closed-menu");
                    menu_items.classList.add("open-menu");

                    if(foundMenu != undefined) {
                        foundMenu.css("z-index", "100000");
                    }
                }
            });
        }
    
        const active = "submenu--active";
        const li_active = "menu__item--has-children--active";
    
        const mobile_menu : any = $(".menu .menu__items--mobile  .menu__item--has-children");
        const submenu = $(".menu .menu__items--mobile .submenu");
        mobile_menu.children(".menu__links").on("click", function (e) {
            const clicked = $(this).next(".submenu");
    
            $(".submenu").not(clicked).removeClass(active);
            $(".menu__item").not($(this).next(mobile_menu).parent()).removeClass(li_active);
    
            clicked.toggleClass(active);
    
            $(this).next(mobile_menu).parent().toggleClass(li_active);
        });

        var desktop_menu = this.containerElement.find(".menu .menu__items--desktop  .menu__item--has-children");
        $(desktop_menu).on('mouseenter', function () {
            $(this).addClass(li_active);
            $(this).find(".submenu").addClass(active);

            console.log('enter');
        });

        $(desktop_menu).on('mouseleave', function () {
            $(this).removeClass(li_active);
            $(this).find(".submenu").removeClass(active);

            console.log('leave');
        });

        $(".menu__links:not(.menu__item--has-children .menu__links), .submenu__item .menu__links").on("click", function () {
            hamburger.classList.remove("header__toggler--active");
            mobile_menu.removeClass(li_active);
            submenu.removeClass(active);
            menu_items.classList.remove("open-menu");
            menu_items.classList.add("closed-menu");
            //body.style.overflowY = "initial";
            //html.style.overflowY = "initial";
        });

        if(menu != undefined) {
            var parsedMenu = $(menu);
            if(parsedMenu.hasClass('menu--sticky')) {
                var fillerElement = parsedMenu.find('.menu-filler');
                var contentElement = parsedMenu.find('#menu-content-container');
        
                var contentElementRects = contentElement[0].getBoundingClientRect();
                fillerElement.css('height', contentElementRects.height);
                //contentElement.css('width', contentElementRects.width);


                var menuPosition = 0;

                setTimeout(() => {
                    var minTop = 0;
                    var starthubsMenu = parsedMenu.parent().find('.starthubs-header');

                    if(starthubsMenu.length > 0) {
                        var starthubsMenuRects = starthubsMenu[0].getBoundingClientRect();
                        menuPosition += starthubsMenuRects.height;
                    }

                    $(window).scroll(function(e){
                        var isPositionFixed = (contentElement.css('position') == 'fixed');
                        var scrollTop = $(this).scrollTop();

                        if (scrollTop > menuPosition && !isPositionFixed){ 
                            contentElement.css({'position': 'fixed', 'top': `${minTop}px`, 'left': '0px'});
                            contentElement.addClass('menu--sticky-content'); 
                            fillerElement.css('display', 'flex');

                            // contentElement.addClass('topbottom-banner-fixed');
                            // contentElement.removeClass('topbottom-banner-relative');
                        }
                        if (scrollTop < menuPosition && isPositionFixed){
                            // contentElement.addClass('topbottom-banner-relative');
                            // contentElement.removeClass('topbottom-banner-fixed');

                            contentElement.css({'position': 'relative', 'top': `0px`});
                            contentElement.removeClass('menu--sticky-content');
                            fillerElement.css('display', 'none');
                        } 
                    });

                    $(window).trigger('scroll');
                }, 500)
            }
        }
        

    }

    private bindNewsletter(containerElement : JQuery<HTMLElement>, blockName : string, finishedSubscribeFromPopupFunction : (title: string, text: string, closeButtonText: string) => void) {
        
        if (typeof (<any> window).setGreCaptcha === 'function') {
        
            (<any> window).setGreCaptcha();
        }

        var form = containerElement.find("form");
        var emailInput = form.find('#Email');
        var termsCheckbox = form.find('input[data-input-element="newsletter-terms"]');
        var additionalInput = form.find('#additional');
        var v2verifyTokenInput = form.find('input[name="V2VerifyToken"]');
        var v3verifyTokenInput = form.find('input[name="V3VerifyToken"]');
        var newsletterOneId = form.find('#NewsletterOneId');
        var newsletterOneCheckbox = form.find('input[data-input-element="newsletter-one"]');
        var newsletterTwoId = form.find('#NewsletterTwoId');
        var newsletterTwoCheckbox = form.find('input[data-input-element="newsletter-two"]');
        var newsletterErrorContainer = form.find('.newsletter-error-container');
        var v2Container = form.find('.recaptcha-v2');
        var recaptchaVersion = 1;
        var submitButton = form.find('button[type="button"]');

        submitButton.off('click').on('click', () => {
            form.trigger('submit');
        })

        $(form).off('submit').on('submit', (e) => {
            if (typeof (<any>window).lintrk != "undefined") {
                (<any>window).lintrk('track', { conversion_id: 5788076 });
            }

            e.preventDefault();
            e.stopImmediatePropagation();
            
            DataService.subscribeToNewsletter(emailInput.val().toString(),
                termsCheckbox.prop('checked'),
                v2verifyTokenInput.val().toString(),
                v3verifyTokenInput.val().toString(),
                additionalInput.val().toString(),
                blockName,
                newsletterOneCheckbox.length == 0 ? newsletterOneId.val().toString() : newsletterOneCheckbox.prop('checked') ? newsletterOneId.val().toString() : null,
                newsletterTwoCheckbox.prop('checked') ? newsletterTwoId.val().toString() : null,
                recaptchaVersion,
                (response) => {
                    if(response.subscribeSuccess) {
                        if(response.redirectToUrl != null && response.redirectToUrl !== '') {
                            location.href = response.redirectToUrl;
                        }
                        else {
                            emailInput.val('');
    
                            DataService.getModalTranslations(ModalTranslationTypes.NewsletterConfirm, (translationResult) => {             
                                if(finishedSubscribeFromPopupFunction != undefined) {
                                    if(translationResult == null) {
                                        finishedSubscribeFromPopupFunction('Nieuwsbrief', response.result, 'sluiten');
                                    }
                                    else {
                                        finishedSubscribeFromPopupFunction(translationResult.title, response.result, translationResult.closeButton);
                                    }
                                }   
                                else {
                                    if(translationResult == null) {
                                        ModalManager.showModal('Nieuwsbrief', response.result, 'sluiten');
                                    }
                                    else {
                                        ModalManager.showModal(translationResult.title, response.result, translationResult.closeButton);
                                    }

                                    emailInput.val('');
                                    v2Container.addClass('d-none');
                                    recaptchaVersion = 1;
                                }       
                            });
                        }
                    }
                    else {
                        if(response.shouldRetryWithRecaptchaV2 && recaptchaVersion == 1) {
                            v2Container.removeClass('d-none');
                            recaptchaVersion = 0;
                            submitButton.prop('disabled', true);
                        }

                        if(finishedSubscribeFromPopupFunction != undefined) {
                            newsletterErrorContainer.html(response.result);
                            newsletterErrorContainer.removeClass('d-none');
                            newsletterErrorContainer.addClass('newsletter-error-container-show');
    
                            setTimeout(() => {
                                newsletterErrorContainer.removeClass('newsletter-error-container-show');
                            }, 5000)
                        }   
                        else {
                            DataService.getModalTranslations(ModalTranslationTypes.NewsletterConfirm, (translationResult) => {             
                                if(translationResult == null) {
                                    ModalManager.showModal('Nieuwsbrief', response.result, 'sluiten');
                                }
                                else {
                                    ModalManager.showModal(translationResult.title, response.result, translationResult.closeButton);
                                }   
                            });
                        }  
                    }
                });
        });
    }

    private bindShowcase() {
        const showcase = this.containerElement.find('.showcase');

        let tab_id = 1;

        const changeTab = () => {
            const totalNavs = showcase.find('.showcase__tabnav');
            const totalTabs = showcase.find('.showcase__tabtxt');

            const active_tabnav = showcase.find('.showcase__tabnav[tab-count*="' + tab_id + '"]');
            const active_tabtxt = showcase.find('.showcase__tabtxt[tab-count*="' + tab_id + '"]');

            totalTabs.each((index, tab) => {
                var tabElement = $(tab);
                tabElement.removeClass('showcase__tabtxt--active');
            });

            totalNavs.each((index, nav) => {
                var navElement = $(nav);
                navElement.removeClass('showcase__tabnav--active');
            });

            active_tabnav?.addClass('showcase__tabnav--active');
            active_tabtxt?.addClass('showcase__tabtxt--active');

            tab_id = (tab_id % totalTabs.length) + 1;
        }

        if(showcase?.hasClass('autoplay')){
            const dataMs = showcase.data('ms');
            
            const ms =  (dataMs) ? dataMs : 5000;
            var autoplay = null;

            $(window).scroll(function(){
                var element = showcase.find('.showcase__container');
                var position = element?.get(0).getBoundingClientRect();
            
                if(position.top >= 0 && position.bottom <= window.innerHeight) {
                    if(autoplay == null) {
                        autoplay = setInterval(changeTab, ms);
                    }
                }
                else if(position.top < window.innerHeight && position.bottom >= 0) {
                    if(autoplay == null) {
                        autoplay = setInterval(changeTab, ms);
                    }
                }
                else {
                    if(autoplay != null) {
                        clearInterval(autoplay);
                        autoplay = null;
                    }
                }
            });
        }

        $(document).on("click", ".showcase__tabnav:not(.showcase__tabnav--active)", function() {
            if(showcase?.hasClass('autoplay')){
                clearInterval(autoplay);
            }

            const tabCount = $(this).attr("tab-count");
            const tabParent = $(this).parents(".showcase__container");

            tabParent.find(".showcase__tabnav--active").removeClass("showcase__tabnav--active");

            $(this).addClass("showcase__tabnav--active");

            tabParent.find(".showcase__tabtxt--active").removeClass("showcase__tabtxt--active");

            tabParent.find(".showcase__tabtxt[tab-count=" + tabCount + "]").addClass("showcase__tabtxt--active");
        });
    }

    private bindSlider() {
        const slides = document.querySelectorAll('.image-slider__image');

        if(slides.length){
            slides.forEach(slide => {
                const link = (slide as any).dataset.href;
                const target = (slide as any).dataset.target;

                if(link){
                    slide.classList.add('image-slider__link');

                    slide.addEventListener('click', () => {
                        window.open(link, target);
                    });
                }
            });
        }
    }

    private bindCookie() {
        var block = this.containerElement.children().first();
        block.find('#acceptReturnUrl').val(location.href);
        block.find('#rejectReturnUrl').val(location.href);

        var stopScrollFunction = function(e) {
            console.log(block);
            
            if(block.css('display') === 'flex') {
                e.preventDefault();
            }
            
        };

        document.addEventListener('wheel', stopScrollFunction, { passive: false });
        document.addEventListener('touchmove', stopScrollFunction, { passive: false });
        document.addEventListener('keydown', stopScrollFunction, { passive: false });
    }

    //#region Side banner
    bindSideBanner(firstElement: JQuery<HTMLElement>) {       
        const initializeSideBanner = () => {
            var currentRotation = this.getRotationDegrees(firstElement);
            var elementBoundingRects = firstElement[0].getBoundingClientRect();
    
            if(currentRotation == 90) {
                firstElement.css('left', `-${elementBoundingRects.x}px`);
            }
            else {
                firstElement.css('right', `-${elementBoundingRects.x + 1}px`);
            }
    
            var viewHeight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
            var top = (viewHeight - firstElement.outerHeight()) / 2;
            firstElement.css('top', `${top}px`);

            var href = firstElement.data('href');

            if(href.length >= 1) {
                var openInNewWindow = firstElement.data('open-in-new-window');
                var target = openInNewWindow == 'True' ? '_blank' : '_self';
                firstElement.on('click', () => {
                    window.open(href, target)
                })
            }
    
            firstElement.animate({
                opacity: 1
            }, 1000);
        }

        setTimeout(() => {
            var trigger : DefaultBlockTrigger = firstElement.data('trigger') as DefaultBlockTrigger;
            switch(trigger) {
                case DefaultBlockTrigger.Instant:
                    initializeSideBanner();
                    break;
                case DefaultBlockTrigger.ShowAfterMs:
                    var amountOfMs : number = firstElement.data('amount-of-milliseconds');
                    setTimeout(initializeSideBanner, amountOfMs);
                    break;
                case DefaultBlockTrigger.UserAction:
                    var id = firstElement.attr('id');
                    var loaded = false;

                    var hash = location.hash.replace( /^#/, '' );
                    if(hash === `${id}--show`) {
                        initializeSideBanner();
                        loaded = true;
                    }

                    window.addEventListener('hashchange', function() {
                        hash = location.hash.replace( /^#/, '' );
                        if(!loaded && hash === `${id}--show`) {
                            initializeSideBanner();
                            loaded = true;
                        }
                    }, false);
                    break;
            }
        }, 50)
    }

    private getRotationDegrees(obj) : number {
        var matrix = obj.css("-webkit-transform") ||
        obj.css("-moz-transform")    ||
        obj.css("-ms-transform")     ||
        obj.css("-o-transform")      ||
        obj.css("transform");
        if(matrix !== 'none') {
            var values = matrix.split('(')[1].split(')')[0].split(',');
            var a = values[0];
            var b = values[1];
            var angle = Math.round(Math.atan2(b, a) * (180/Math.PI));
        } else { var angle = 0; }
    
        if(angle < 0) angle +=360;
        return angle;
    }

    //#endregion

    //#region Banner

    bindBanner(firstElement: JQuery<HTMLElement>) {
        var self = this;
        var cookieName = `${this.blockTag}-dismiss`;
        var cookie = CookieHelper.getCookie(cookieName);
        if(cookie != undefined && cookie.length >= 1) {
            firstElement.parent().remove();
            firstElement.remove();
        }
        else {
            const initializeBanner= (isInstant:boolean = false) => {
                var fillerElement = firstElement.find('.topbottom-banner-filler');
                var contentElement = firstElement.find('.topbottom-banner-content');
                var hoverContainer = firstElement.find('.topbottom-banner-hover-container');
                var mobileChevronCloseContainer = firstElement.find('.mobile-close-chevron-container');
                var dismissButton = firstElement.find('.banner-dismiss-button');
                var isBottom = contentElement.hasClass('topbottom-banner-bottom');

                var displayFunction = () => {
                    setTimeout(() => {
                        if(isInstant) {
                            contentElement.css('transition', 'all 0s linear');
                            contentElement.css('opacity', '1');

                            setTimeout(() => {
                                contentElement.css('transition', '');
                            }, 50)
                        }
                        else {
                            contentElement.css('transition', 'all 1s linear');
                            contentElement.css('opacity', '1');

                            setTimeout(() => {
                                contentElement.css('transition', '');
                            }, 1000)
                        }
                    }, 100);
                };

                if(!isBottom) {
                    firstElement.css('display', 'initial');
                    displayFunction();
                }

                var dismissFor : BannerDismissFor = firstElement.data('dismiss-for') as BannerDismissFor;
                var isDismissableDataField = firstElement.data('dismissable');
                var isDismissable = isDismissableDataField == 'True' ? true : false;
    
                if(isDismissable) {
                    dismissButton.on('click', (e) => {
                        e.stopPropagation();
                        e.stopImmediatePropagation();
                        
                        var disableTimeout = 200;
                        if(contentElement.hasClass('topbottom-banner-closed')) {
                            disableTimeout = 0;
                        }

                        firstElement.trigger('mouseleave');

                        setTimeout(() => {
                            contentElement.toggleClass('animate');
                            switch(dismissFor) {
                                case BannerDismissFor.Session:
                                    CookieHelper.setCookie(cookieName, "true");
                                    break;
                                case BannerDismissFor.OneDay:
                                    CookieHelper.setCookie(cookieName, "true", 1);
                                    break;
                                case BannerDismissFor.ThreeDays:
                                    CookieHelper.setCookie(cookieName, "true", 3);
                                    break;
                                case BannerDismissFor.OneWeek:
                                    CookieHelper.setCookie(cookieName, "true", 7);
                                    break;
                                case BannerDismissFor.OneMonth:
                                    CookieHelper.setCookie(cookieName, "true", 31);
                                    break;
                            }
                            setTimeout(() => {
                                firstElement.remove();
                            }, 500)
                        }, disableTimeout)
                    })
                }
        
                var contentElementRects = contentElement[0].getBoundingClientRect();
                fillerElement.css('height', contentElementRects.height);
                contentElement.css('width', contentElementRects.width);
           
                var setMaxHeight = () => {
                    if(hoverContainer == undefined || hoverContainer.length == 0) {
                        return;
                    }

                    var hoverContainerRects = hoverContainer[0].getBoundingClientRect();
                    var height = hoverContainerRects.height + 50;

                    if(mobileChevronCloseContainer.length >= 1) {
                        var mobileChevronCloseRects = mobileChevronCloseContainer[0].getBoundingClientRect();
                        height += mobileChevronCloseRects.height;
                    }

                    contentElement.css('max-height', `${height}px`);

                    contentElement.addClass('topbottom-banner-open');
                    contentElement.removeClass('topbottom-banner-closed');
                }

                mobileChevronCloseContainer.on('click', (e) => {
                    e.stopPropagation();
                    firstElement.trigger('mouseleave');
                });

                firstElement.hover(
                    function(e) {
                        if(!e.target.classList.contains('fas')) {
                            setMaxHeight();
                        }
                    }, function() {
                        contentElement.css('max-height', '');
                        contentElement.removeClass('topbottom-banner-open');
                        contentElement.addClass('topbottom-banner-closed');
                    }
                );

                contentElement.on('click', (e) => {
                    e.stopPropagation();
                    setMaxHeight();
                })

                var menuPosition = 0;
                var starthubsFooter = $('.footer-starthub');
                if(isBottom) { 
                    setTimeout(() => {                        
                        firstElement.css('display', 'initial');
                        displayFunction();

                        var firstElementsRects = firstElement[0].getBoundingClientRect();

                        if(starthubsFooter.length == 0) {
                            starthubsFooter = $('.footer-starthub');
                        }

                        if(starthubsFooter.length == 0) {
                            jQuery('<div>', {
                                id: 'dummy-footer',
                                style: `height: 50px`,
                            }).appendTo('body');

                            var dummyFooter = $('#dummy-footer')
                            firstElement.insertBefore(dummyFooter);
                        }
                        else {
                            firstElement.insertBefore(starthubsFooter);
                        }

                        contentElement.css('width', firstElementsRects.width);

                        $(window).trigger('scroll');
                    }, 250);
                }
                else {
                    var menu = $('.starthubs-header');
                    if(menu.length >= 1) {
                        var menuRects = menu[0].getBoundingClientRect();
                        menuPosition = menuRects.height;
                    }
                }

                $(window).scroll(function(e){
                    var isPositionFixed = (contentElement.css('position') == 'fixed');
                    var scrollTop = $(this).scrollTop();

                    if(isBottom) {
                        if(starthubsFooter.length >= 1) {
                            if(self.isElementInView(firstElement)) {
                                contentElement.css({'position': 'relative', 'bottom': '0px'});
                                fillerElement.css('display', 'none');

                                contentElement.addClass('topbottom-banner-relative');
                                contentElement.removeClass('topbottom-banner-fixed');
                            }
                            else {
                                contentElement.css({'position': 'fixed', 'bottom': '0px'}); 
                                fillerElement.css({'display': 'flex', 'width': '100%'});  

                                contentElement.addClass('topbottom-banner-fixed');
                                contentElement.removeClass('topbottom-banner-relative');
                            }
                        }
                        else {
                            contentElement.css({'position': 'fixed', 'bottom': '0px'}); 
                            fillerElement.css({'display': 'flex', 'width': '100%'});  

                            contentElement.addClass('topbottom-banner-fixed');
                            contentElement.removeClass('topbottom-banner-relative');
                        }

                        if(mobileChevronCloseContainer.length >= 1) {
                            var mobileChevronIconElement = mobileChevronCloseContainer.find('.fa');
                            if(isPositionFixed) {
                                mobileChevronIconElement.removeClass('fa-chevron-up');
                                mobileChevronIconElement.addClass('fa-chevron-down');
                            }
                            else {
                                mobileChevronIconElement.removeClass('fa-chevron-down');
                                mobileChevronIconElement.addClass('fa-chevron-up');
                            }
                        }
                    }
                    else {
                        if (scrollTop > menuPosition && !isPositionFixed){ 
                            contentElement.css({'position': 'fixed', 'top': '0px'}); 
                            fillerElement.css('display', 'flex');

                            contentElement.addClass('topbottom-banner-fixed');
                            contentElement.removeClass('topbottom-banner-relative');
                        }
                        if (scrollTop < menuPosition && isPositionFixed){
                            contentElement.addClass('topbottom-banner-relative');
                            contentElement.removeClass('topbottom-banner-fixed');

                            contentElement.css({'position': 'relative', 'top': '0px'});
                            fillerElement.css('display', 'none');
                        } 
                    }
                });
            }

            setTimeout(() => {
                var trigger : DefaultBlockTrigger = firstElement.data('trigger') as DefaultBlockTrigger;
                switch(trigger) {
                    case DefaultBlockTrigger.Instant:
                        initializeBanner(true);
                        break;
                    case DefaultBlockTrigger.ShowAfterMs:
                        var amountOfMs : number = firstElement.data('amount-of-milliseconds');
                        setTimeout(initializeBanner, amountOfMs);
                        break;
                    case DefaultBlockTrigger.UserAction:
                        var id = firstElement.attr('id');
                        var loaded = false;

                        var hash = location.hash.replace( /^#/, '' );
                        if(hash === `${id}--show`) {
                            initializeBanner(true);
                            loaded = true;
                        }

                        window.addEventListener('hashchange', function() {
                            hash = location.hash.replace( /^#/, '' );
                            if(!loaded && hash === `${id}--show`) {
                                initializeBanner(true);
                                loaded = true;
                            }
                        }, false);
                        break;
                }
            }, 50)
        }
    }

    private isElementInView(element) : boolean {
        let elementTop = element.offset().top;
        let elementBottom = elementTop + element.outerHeight();
      
        let viewportTop = $(window).scrollTop();
        let viewportBottom = viewportTop + window.innerHeight;
      
        return elementBottom > viewportTop && elementTop < viewportBottom;
    }

    //#endregion

    //#region Popup

    bindPopup(firstElement: JQuery<HTMLElement>) {
        var self = this;
        var cookieName = `${this.blockTag}-dismiss`;
        var cookie = CookieHelper.getCookie(cookieName);
        if(cookie != undefined && cookie.length >= 1) {
            firstElement.parent().remove();
            firstElement.remove();
        }
        else {
            const initializePopup= () => {
                firstElement.addClass('popup--shown');
                var dismissButton = firstElement.find('.modal__close');

                var dismissFor : BannerDismissFor = firstElement.data('dismiss-for') as BannerDismissFor;
                var dismissFunction = (e) => {
                    e.stopPropagation();
                    e.stopImmediatePropagation();

                    firstElement.toggleClass('animate');
                    switch(dismissFor) {
                        case BannerDismissFor.Session:
                            CookieHelper.setCookie(cookieName, "true");
                            break;
                        case BannerDismissFor.OneDay:
                            CookieHelper.setCookie(cookieName, "true", 1);
                            break;
                        case BannerDismissFor.ThreeDays:
                            CookieHelper.setCookie(cookieName, "true", 3);
                            break;
                        case BannerDismissFor.OneWeek:
                            CookieHelper.setCookie(cookieName, "true", 7);
                            break;
                        case BannerDismissFor.OneMonth:
                            CookieHelper.setCookie(cookieName, "true", 31);
                            break;
                    }

                    setTimeout(() => {
                        firstElement.removeClass('popup--shown');
                    }, 1000)

                    setTimeout(() => {
                        firstElement.removeClass('animate');
                    }, 2000)
                }


                dismissButton.on('click', (e) => {
                    dismissFunction(e);
                })

                if(firstElement.data('content-type') == 'newsletter') {
                    this.bindNewsletter(firstElement, firstElement.data('newsletter-block-name'), (title, text, closeButtonText) => {
                        var modalContent = firstElement.find('.modal__content');
                        modalContent.addClass('d-block');
                        modalContent.html(`
                        <i class="fas fa-times modal__close"></i>
                        <h4 id="modal_title" class="mt-none">${title}</h4>
                        <p id="modal_text">${text}</p>
                        <button id="modal_button" class="btn btn--secondary">${closeButtonText}</button>`);

                        var newClosedButton = modalContent.find('.modal__close');
                        var primaryCloseButton = modalContent.find('#modal_button');

                        newClosedButton.on('click', (e) => {
                            dismissFunction(e);
                        });
                        
                        primaryCloseButton.on('click', (e) => {
                            dismissFunction(e);
                        });
                    });
                }
            }

            setTimeout(() => {
                var trigger : DefaultBlockTrigger = firstElement.data('trigger') as DefaultBlockTrigger;
                switch(trigger) {
                    case DefaultBlockTrigger.Instant:
                        initializePopup();
                        break;
                    case DefaultBlockTrigger.ShowAfterMs:
                        var amountOfMs : number = firstElement.data('amount-of-milliseconds');
                        setTimeout(initializePopup, amountOfMs);
                        break;
                    case DefaultBlockTrigger.UserAction:
                        var id = firstElement.attr('id');

                        var hash = location.hash.replace( /^#/, '' );
                        if(hash === `${id}--show`) {
                            initializePopup();
                            window.history.replaceState({}, '', window.location.href.split('#')[0]);
                            window.history.back();
                        }

                        window.addEventListener('hashchange', function() {
                            hash = location.hash.replace( /^#/, '' );
                            if(hash === `${id}--show`) {
                                initializePopup();
                                window.history.replaceState({}, '', window.location.href.split('#')[0]);
                                window.history.back();
                            }
                        }, false);
                        break;
                }
            }, 50)
        }
    }

    //#endregion

    //#region Icon row

    bindIconRow(firstElement: JQuery<HTMLElement>) {
        firstElement.find('div.border-radius-circle').each((index, element) => {
            var iconElement = $(element);
            var iconElementRects = iconElement[0].getBoundingClientRect();

            iconElement.css('height', iconElementRects.width);
            iconElement.css('width', iconElementRects.width);
        });
    }

    //#endregion

    //#region email form

    bindEmailFormBlock(firstElement: JQuery<HTMLElement>) {
        var submitButton = firstElement.find('button.submit-button');
        var emailForm = firstElement.find('form');
        var alertBox = firstElement.find('#alert-box');
        var v2Container = emailForm.find('.recaptcha-v2');

        var recaptchaVersionInput = emailForm.find('input[name="RecaptchaVersion"]');
        var recaptchaVersion = 1;

        var validateElement = (elementToValidate) => {
            if(!elementToValidate.is(':valid')) {
                elementToValidate.addClass('input--red');
                return false;
            }
            else {
                elementToValidate.removeClass('input--red');
            }

            return true;
        }

        emailForm.find('.input').each((index, element) => {
            var parsedElement = $(element);

            parsedElement.on('change', () => {
                validateElement(parsedElement);
            });
        })

        emailForm.off('submit').on('submit', (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();

            var isValid = true;

            emailForm.find('.input').each((index, element) => {
                var parsedElement = $(element);

                var validateResult = validateElement(parsedElement);
                if(!validateResult) {
                    isValid = false;
                }
            })

            if(isValid) {
                submitButton.prop('disabled', true);
                
                $.ajax({
                    url: `/common/sendemailform`,
                    type: 'post',
                    dataType: 'json',
                    data: emailForm.serialize(),
                    success: (result : EmailFormResult) => {
                        if(result.result == true) {
                            emailForm.parent().html(`<div class="h-100 d-flex"><div class="my-auto">${result.message}</div></div>`);
                        }
                        else {
                            submitButton.prop('disabled', false);
                            alertBox.html(result.message);
                            alertBox.addClass('show');

                            v2Container.removeClass('d-none');
                            recaptchaVersionInput.val('0');

                            
                            setTimeout(() => {
                                alertBox.addClass('hide');

                                setTimeout(() => {
                                    alertBox.removeClass('show');
                                    alertBox.removeClass('hide');
                                }, 1000)
                            }, 5000)
                        }
                    }
                });
            }
        });
    }

    //#endregion

    //#region faq block

    bindFaqBlock(firstElement: JQuery<HTMLElement>) {
        firstElement.find(".faq__item").each(function(){
            $(this).on("click", function(e){
                if($(this).hasClass('faq__item_open')){
                    $(this).removeClass('faq__item_open');
                    $(this).find('.faq__item_text').addClass("d-none");
                    $(this).find('.faq__item_icon').addClass(' fa-chevron-down');
                    $(this).find('.faq__item_icon').removeClass(' fa-chevron-up');
                    $(this).find('.dropdown').removeClass('d-none');
                    $(this).find('.dropdown-close').addClass('d-none');

                }
                else{
                    $(this).addClass('faq__item_open');
                    $(this).find('.faq__item_text').removeClass("d-none")
                    $(this).find('.faq__item_icon').removeClass('fa-chevron-down');
                    $(this).find('.faq__item_icon').addClass('fa-chevron-up');
                    $(this).find('.dropdown').addClass('d-none');
                    $(this).find('.dropdown-close').removeClass('d-none');
                }
            });
        })
    }

    //#endregion

    //#region parallax

    bindParallax(firstElement : JQuery<HTMLElement>) {
        var self = this;
        //initParallax();

        var currentPercentage = 0;

        function parallaxImg (img : JQuery<HTMLElement>, imgParent: JQuery<HTMLElement>) {
            var speed = img.data('speed');
            var imgY = imgParent.offset().top;
            var winY = $(window).scrollTop();
            var winH = $(window).height();
            var parentH = imgParent.innerHeight();
        
            // The next pixel to show on screen      
            var winBottom = winY + winH;
        
            // If block is shown on screen
            if (winBottom > imgY && winY < imgY + parentH) { 
                // Number of pixels shown after block appear
                var imgBottom = ((winBottom - imgY) * speed);
                // Max number of pixels until block disappear
                var imgTop = winH + parentH;
                // Porcentage between start showing until disappearing
                var imgPercent = ((imgBottom / imgTop) * 100) + (50 - (speed * 50));
                currentPercentage = imgPercent;

                if(currentPercentage > 100) {
                    imgPercent = 100;
                }
                if(currentPercentage <= 0) {
                    imgPercent = 0;
                }

                img.css({
                    top: imgPercent + '%',
                    transform: 'translate(-50%, -' + imgPercent + '%)'
                });
            }
        }

        $('.img-parallax').each(function(){
            var img = $(this);
            var imgParent = $(this).parent();

            $(document).on({
              scroll: function () {
                parallaxImg(img, imgParent);
              }
            });

            img.css('opacity', '0');
            setTimeout(() => {
                parallaxImg(img, imgParent);
                img.css('opacity', '1');
            }, 50)

        });
    }

    //#endregion
}

